import Axios from './Axios'
import { AUTH_SERVICE_URL, API_REQUESTS } from '../helper/constant'

class PasswordHandling extends Axios {

    /* Fetch all packagingList  */
    static async initiateForgotPassword(payload) {
        return new Promise((resolve, reject) => {
            const INIT_FORGOT_URL = `${AUTH_SERVICE_URL}${API_REQUESTS.INIT_FORGOT_PSWD}`
            this.axios.post(INIT_FORGOT_URL, payload).then((response) => {
                return resolve(response.data)
            })
                .catch(error => {
                    //console.log(`password handling error is :`, error)
                    return reject(error)
                })
        })
    }

    /* Confirm New Password  */
    static async confirmPasswordResponse(payload) {
        return new Promise((resolve,reject)=> {
            const CONFIRM_FORGOT_URL = `${AUTH_SERVICE_URL}${API_REQUESTS.CONFIRM_FORGOT_URL}`
            this.axios.post(CONFIRM_FORGOT_URL, payload).then((response)=> {
                return resolve(response.data)
            })
            .catch(error => {
               // console.log(`confirm password error is :`, error);
                return reject(error)
            })
        })
    }

    /*  on Change New Admin User Password */
    static async onChangeNewPassword(payload) {
        return new Promise((resolve,reject)=> {
            const URL = `${AUTH_SERVICE_URL}/portal/changePassword`
            this.axios.post(URL, payload).then((response)=> {
                return resolve(response.data)
            })
            .catch(error => {
               // console.log(`confirm password error is :`, error);
                return reject(error)
            })
        })
    }

}
export default PasswordHandling